import Webline from 'components/Layout/Webline/Webline';
import styled, { css } from 'styled-components';

type SearchResultsBlockStyledProps = {
    areAllResultsVisible: boolean;
};

export const SearchResultsBlockStyled = styled.div<SearchResultsBlockStyledProps>`
    ${({ theme, areAllResultsVisible }) => css`
        @media ${theme.mediaQueries.queryLg} {
            max-height: ${areAllResultsVisible ? 'none' : '150px'};
            overflow: hidden;
        }
    `}
`;

export const SearchResultsWeblineStyled = styled(Webline)`
    margin-top: 24px;
`;

export const ShowResultsButtonWrapperStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: center;
        margin: 20px 0;

        @media ${theme.mediaQueries.queryTablet} {
            display: none;
        }
    `}
`;
